import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator/index';
import { withTheme } from '@material-ui/core';
import { FHEListProduct } from 'data/components/index';
import {
    SvgSDM17SPGIcon,
    SvgSDM18HCLIcon,
    SvgSDM18SP2Icon,
    SvgSecurityModemIcon,
    SvgSDM18HCNIcon,
    SvgSDM18MVRIcon,
    SvgAirzoneIcon,
    SvgSDM19DE2Icon,
    SvgSDM17SPTIcon,
    SvgSDM16SPMIcon,
    SvgSDM17DECIcon,
    SvgSDM19DEEIcon,
    SvgSDM19STMIcon
} from 'data/common/iconsvg/index';

class OneWifiProduct extends PureComponent {
    static propTypes = {
        theme: PropTypes.object.isRequired,
        product: PropTypes.object.isRequired
    };

    static defaultProps = {};

    getSvgIcon = () => {
        const { product, theme } = this.props;
        switch (product.product_type) {
            case 'SDM17SPG':
                return <SvgSDM17SPGIcon color={theme.palette.primary.main} secondaryColor={theme.palette.common.white} size={40} />;
            case 'airzone':
                return <SvgAirzoneIcon color={theme.palette.primary.main} secondaryColor={theme.palette.common.white} size={40} />;
            case 'SDM18HCL':
                return <SvgSDM18HCLIcon color={theme.palette.primary.main} secondaryColor={theme.palette.common.white} size={40} />;
            case 'security':
                return <SvgSecurityModemIcon color={theme.palette.primary.main} secondaryColor={theme.palette.common.white} size={40} />;
            case 'SDM18HCN':
                return <SvgSDM18HCNIcon color={theme.palette.primary.main} secondaryColor={theme.palette.common.white} size={40} />;
            case 'SDM18SP2':
                return <SvgSDM18SP2Icon color={theme.palette.primary.main} secondaryColor={theme.palette.common.white} size={40} />;
            case 'SDM18MVR':
                return <SvgSDM18MVRIcon color={theme.palette.primary.main} secondaryColor={theme.palette.common.white} size={40} />;
            case 'SDM19DE2':
                return <SvgSDM19DE2Icon color={theme.palette.primary.main} secondaryColor={theme.palette.common.white} size={40} />;
            case 'SDM17SPT':
                return <SvgSDM17SPTIcon color={theme.palette.primary.main} secondaryColor={theme.palette.common.white} size={40} />;
            case 'SDM16SPM':
                return <SvgSDM16SPMIcon color={theme.palette.primary.main} secondaryColor={theme.palette.common.white} size={40} />;
            case 'SDM17DEC':
                return <SvgSDM17DECIcon color={theme.palette.primary.main} secondaryColor={theme.palette.common.white} size={40} />;
            case 'SDM19DEE':
                return <SvgSDM19DEEIcon color={theme.palette.primary.main} secondaryColor={theme.palette.common.white} size={40} />;
            case 'SDM19STM':
                return <SvgSDM19STMIcon color={theme.palette.primary.main} secondaryColor={theme.palette.common.white} size={40} />;
            default:
                return <SvgSDM18HCNIcon color={theme.palette.primary.main} secondaryColor={theme.palette.common.white} size={40} />;
        }
    };

    render() {
        const { product } = this.props;

        let productLabel = '';
        if (Translator.isTranslationExist(`generic.products.addProduct.widgetsList.${product.product_type}`)) {
            productLabel = Translator.translate(`generic.products.addProduct.widgetsList.${product.product_type}`);
        } else {
            productLabel = Translator.translate(`generic.products.addProduct.widgetsList.unknownProduct`);
        }

        return (
            <Fragment>
                <FHEListProduct
                    primary={productLabel}
                    secondary={product.ssid}
                    thirdly={product.bssid
                        .toUpperCase()
                        .match(/.{1,2}/g)
                        .join(':')}
                    icon={this.getSvgIcon()}
                />
            </Fragment>
        );
    }
}

export default withTheme(OneWifiProduct);



// WEBPACK FOOTER //
// ./data/components/OneWifiProduct.js